export default __webpack_public_path__ + "static/media/icon_ahk.c1df4305.webp";